import { ticoticketApi } from "../ticoticketApi";
import Cookies from "js-cookie";

import { OrganizationInterface } from "../../interfaces";

export const getPlannerOrganization = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/planner/organization", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updatePlannerOrganizationData = async (updatedFields: OrganizationInterface) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put(
      "/planner/update/organization",
      updatedFields,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};
